const STATUS = {
    ACTIVE: 1,
    INACTIVE: 0
}

export const STATUS_LABEL = {
    [STATUS.ACTIVE]: {
        label: 'Active',
        color: 'green',
        status: STATUS.ACTIVE
    },
    [STATUS.INACTIVE]: {
        label: 'Inactive',
        color: 'default',
        status: STATUS.INACTIVE
    },
}

export const DRIVER_LICENSE_STATUS_BY_CODE = {
    '000': 'Upcoming',
    '001': 'Due Soon',
    '002': 'Overdue',
}

export const DRIVER_LICENSE_STATUS_CODE_BY_STATUS = {
    "UPCOMING": '000',
    'DUE_SOON': '001',
    'OVERDUE': '002',
}

export const DRIVER_LICENSE_STATUS_COLOR_BY_CODE = {
    '000': 'green',
    '001': 'orange',
    '002': 'red',
}

export const DRIVER_PRETRIP_CATEGORY_CODE = {
    'DAILY_MAINTENANCE':       'PH',  // Penyelenggaraan Harian
    'GENERAL_REQUIREMENTS':    'SU',  // Syarat-Syarat Umum
    'DRIVING_HOURS':           'DW',  // Pematuhan Had Waktu Memandu
    'DRIVER_REPLACEMENT':      'PD',  // Penukaran Pemandu
    'SAFETY_EQUIPMENT':        'SE',  // Peralatan Keselamatan
    'CARGO_CHECK':             'MU',  // Semakan Keselamatan Bagi Muatan
}

export const DRIVER_PRETRIP_CHECKLIST_CATEGORY_LABEL = {
    [DRIVER_PRETRIP_CATEGORY_CODE.DAILY_MAINTENANCE]:    'Daily Maintenance',
    [DRIVER_PRETRIP_CATEGORY_CODE.GENERAL_REQUIREMENTS]: 'General Requirements',
    [DRIVER_PRETRIP_CATEGORY_CODE.DRIVING_HOURS]:        'Driving Hours Compliance',
    [DRIVER_PRETRIP_CATEGORY_CODE.DRIVER_REPLACEMENT]:   'Driver Replacement',
    [DRIVER_PRETRIP_CATEGORY_CODE.SAFETY_EQUIPMENT]:     'Safety Equipment',
    [DRIVER_PRETRIP_CATEGORY_CODE.CARGO_CHECK]:          'Cargo Safety Check',
}

export const DRIVER_PRETRIP_CHECKLIST_CATEGORY_LABEL_MALAY = {
    [DRIVER_PRETRIP_CATEGORY_CODE.DAILY_MAINTENANCE]:    'Penyelenggaraan Harian',
    [DRIVER_PRETRIP_CATEGORY_CODE.GENERAL_REQUIREMENTS]: 'Syarat-Syarat Umum',
    [DRIVER_PRETRIP_CATEGORY_CODE.DRIVING_HOURS]:        'Pematuhan Had Waktu Memandu Dan Bekerja',
    [DRIVER_PRETRIP_CATEGORY_CODE.DRIVER_REPLACEMENT]:   'Penukaran Pemandu',
    [DRIVER_PRETRIP_CATEGORY_CODE.SAFETY_EQUIPMENT]:     'Peralatan Keselamatan',
    [DRIVER_PRETRIP_CATEGORY_CODE.CARGO_CHECK]:          'Semakan Keselamatan Bagi Muatan Yang Dibawa',
}


export const DRIVER_PRETRIP_RISK_CODE = {
    'LOW': 0,
    'MEDIUM': 1,
    'HIGH': 2
}

export const DRIVER_PRETRIP_RISK_LABEL = {
    [DRIVER_PRETRIP_RISK_CODE.LOW]: 'LOW',
    [DRIVER_PRETRIP_RISK_CODE.MEDIUM]: 'MEDIUM',
    [DRIVER_PRETRIP_RISK_CODE.HIGH]: 'HIGH',
}

export const DRIVER_PRETRIP_RISK_COLOR = {
    [DRIVER_PRETRIP_RISK_LABEL[DRIVER_PRETRIP_RISK_CODE.LOW]]: 'grey',
    [DRIVER_PRETRIP_RISK_LABEL[DRIVER_PRETRIP_RISK_CODE.MEDIUM]]: 'orange',
    [DRIVER_PRETRIP_RISK_LABEL[DRIVER_PRETRIP_RISK_CODE.HIGH]]: 'red',
}

export const DRIVER_PRETRIP_CHECKLIST_CATEGORY_CODES = Object.values(DRIVER_PRETRIP_CATEGORY_CODE)